/****************************************************
 * Module Name:  remarkProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class RemarkProxy {
    static GetAllRemark = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/remarkcategory",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetAllRemarkMini = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/remarkcategory/mini",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetSingleRemark = (remarkid, callback) => {
        let params = {
            id: remarkid,
        };

        restAPICall(
            Constants.MANAGER_URL + "/remarkcategory",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static CheckRemarkAvailable = (remarkcategory, callback) => {
        let params = {
            remarkcategory: remarkcategory,
        };

        restAPICall(
            Constants.MANAGER_URL + "/remarkcategory/available",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddRemark = (shape, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/remarkcategory",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(shape),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UpdateRemark = (shape, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/remarkcategory",
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(shape),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}
